<template>
  <div class="quiz-center-page">
    <header class="quiz-center-header">
      <button class="quiz-center-back" type="button" :aria-label="$t('Back')" @click="back">
        <img src="../../static/images/livequiz/back.png" alt="" />
      </button>
    </header>

    <main class="quiz-center-content">
      <img class="quiz-center-title" src="../../static/images/quiz_center/quiz_center_title.png" :alt="$t('homeGame2T')" />

      <section class="quiz-center-grid" :aria-label="$t('homeGame2T')">
        <button class="quiz-center-card word-mode-card" type="button" @click="goBattleRoom('waitRobot')">
          <img class="quiz-center-card-art" src="../../static/images/word_quiz/ai_training.png" alt="" />
          <span class="quiz-center-card-copy">
            <img src="../../static/images/quiz_center/txt_bg.png" alt="" />
            <strong>{{ $t('WordQuizAITraining') }}</strong>
            <em>{{ $t('WordQuizAITrainingC') }}</em>
          </span>
        </button>

        <button class="quiz-center-card word-mode-card" type="button" @click="goBattleRoom('paiwei')">
          <img class="quiz-center-card-art" src="../../static/images/word_quiz/ranked_mode.png" alt="" />
          <span class="quiz-center-card-copy">
            <img src="../../static/images/quiz_center/txt_bg.png" alt="" />
            <strong>{{ $t('WordQuizRankedMode') }}</strong>
            <em>{{ $t('WordQuizRankedModeC') }}</em>
          </span>
        </button>

        <button class="quiz-center-card word-mode-card" type="button" @click="goBattleRoom('pk')">
          <img class="quiz-center-card-art" src="../../static/images/word_quiz/team_mode.png" alt="" />
          <span class="quiz-center-card-copy">
            <img src="../../static/images/quiz_center/txt_bg.png" alt="" />
            <strong>{{ $t('WordQuizTeamMode') }}</strong>
            <em>{{ $t('WordQuizTeamModeC') }}</em>
          </span>
        </button>

        <button class="quiz-center-card word-mode-card" type="button" @click="goBattleRoom('single')">
          <img class="quiz-center-card-art" src="../../static/images/word_quiz/endless_mode.png" alt="" />
          <span class="quiz-center-card-copy">
            <img src="../../static/images/quiz_center/txt_bg.png" alt="" />
            <strong>{{ $t('WordQuizEndlessMode') }}</strong>
            <em>{{ $t('WordQuizEndlessModeC') }}</em>
          </span>
        </button>

        <button class="quiz-center-card" type="button" @click="goBattleRoom('ImageQuestion', 'picture')">
          <img class="quiz-center-card-art" src="../../static/images/quiz_center/guess_words.png" alt="" />
          <span class="quiz-center-card-copy">
            <img src="../../static/images/quiz_center/txt_bg.png" alt="" />
            <strong>{{ $t('GuessWords') }}</strong>
            <em>{{ $t('QuizCenterGuessWordsC') }}</em>
          </span>
        </button>

        <button class="quiz-center-card" type="button" @click="goBattleRoom('musicQuestion', 'music')">
          <img class="quiz-center-card-art" src="../../static/images/quiz_center/music_quiz.png" alt="" />
          <span class="quiz-center-card-copy">
            <img src="../../static/images/quiz_center/txt_bg.png" alt="" />
            <strong>{{ $t('MusicQuiz') }}</strong>
            <em>{{ $t('QuizCenterMusicQuizC') }}</em>
          </span>
        </button>

        <button class="quiz-center-card" type="button" @click="goBattleRoom('videoQuestion', 'video')">
          <img class="quiz-center-card-art" src="../../static/images/quiz_center/video_quiz.png" alt="" />
          <span class="quiz-center-card-copy">
            <img src="../../static/images/quiz_center/txt_bg.png" alt="" />
            <strong>{{ $t('VideoQuiz') }}</strong>
            <em>{{ $t('QuizCenterVideoQuizC') }}</em>
          </span>
        </button>
      </section>
    </main>

  </div>
</template>

<script>
export default {
  data() {
    return {
      info: {}
    }
  },
  created() {
    this.getCheckChance()
  },
  methods: {
    back() {
      this.$router.push({path: '/'})
    },
    getCheckChance() {
      const that = this
      that.$parent.loadModal(true)
      that.$api.post('/api/question/check_chance', null, r => {
        that.info = r.data || {}
        that.$parent.loadModal(false)
      })
    },
    goBattleRoom(url, type) {
      if (!type) {
        this.$router.push({path: '/' + url})
        return
      }

      const chanceKey = {
        picture: 'picture_chance',
        music: 'music_chance',
        video: 'video_chance'
      }[type]

      if (chanceKey && Number(this.info[chanceKey] || 0) < 1) {
        this.$utils.alertText(this.$t('notChances'), 80)
        return
      }

      this.$router.push({path: '/' + url, query: {question_type: type}})
    }
  }
}
</script>

<style scoped>
.quiz-center-page {
  min-height: 100vh;
  padding: 46px 28px 96px;
  box-sizing: border-box;
  background: #080126 url('../../static/images/livequiz/main_bg.jpg') no-repeat center top;
  background-size: 100% 100%;
  color: #fff;
  font-family: Arial, Atom-sans, sans-serif;
}

.quiz-center-page::before {
  position: fixed;
  z-index: 0;
  inset: 0;
  content: '';
  background: linear-gradient(180deg, rgba(12, 0, 44, .04), rgba(8, 0, 34, .48) 58%, rgba(7, 0, 29, .9));
  pointer-events: none;
}

.quiz-center-back,
.quiz-center-card {
  border: 0;
  padding: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.quiz-center-header {
  position: absolute;
  z-index: 2;
  top: 46px;
  right: 0;
  left: 0;
  width: calc(100% - 56px);
  max-width: 650px;
  margin: 0 auto;
}

.quiz-center-back {
  width: 72px;
  height: 72px;
}

.quiz-center-back img { display: block; width: 100%; height: 100%; }

.quiz-center-content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
}

.quiz-center-title {
  display: block;
  width: min(78%, 520px);
  margin: 0 auto 58px;
}

.quiz-center-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 14px;
}

.quiz-center-card {
  position: relative;
  display: block;
  min-width: 0;
  overflow: hidden;
  border-radius: 28px;
}

.quiz-center-card-art { display: block; width: 100%; }

.quiz-center-card-copy {
  position: absolute;
  right: 3%;
  bottom: 3%;
  left: 3%;
  display: block;
  height: 42%;
  overflow: hidden;
  border-radius: 18px;
}

.quiz-center-card-copy > img { display: block; width: 100%; height: 100%; }

.quiz-center-card-copy strong,
.quiz-center-card-copy em {
  position: absolute;
  right: 7%;
  left: 7%;
  text-align: center;
}

.word-mode-card .quiz-center-card-copy { height: 46%; }
.word-mode-card .quiz-center-card-copy strong { top: 5%; font-size: clamp(14px, 4.2vw, 30px); letter-spacing: -.035em; white-space: nowrap; }
.word-mode-card .quiz-center-card-copy em { top: 30%; font-size: clamp(11px, 3.2vw, 25px); }

.quiz-center-card-copy strong {
  top: 14%;
  color: #fff;
  font-size: clamp(18px, 5.1vw, 35px);
  font-weight: 900;
  line-height: 1;
  letter-spacing: -.045em;
  text-shadow: 0 3px 3px rgba(33, 0, 25, .86);
  text-transform: uppercase;
}

.quiz-center-card-copy em {
  top: 47%;
  color: #ffe968;
  font-size: clamp(13px, 3.6vw, 25px);
  font-style: normal;
  font-weight: 500;
  white-space: pre-line;
}

@media (min-width: 760px) {
  .quiz-center-page { padding-top: 46px; }
  .quiz-center-title { margin-bottom: 72px; }
}
</style>



// WEBPACK FOOTER //
// src/page/quizCenter.vue